@if (initialized && ticket) {


  <div class="grid">

    <div class="col-12 xl:col-5 p-3">
      <div class="surface-card p-4 border-round h-full">
        <div class="font-medium text-3xl text-900 mb-3">{{ ticket.alias }}</div>
        <div class="text-500 mb-3">{{ ticket.name }}</div>
        <ul class="list-none px-0 pt-3 m-0 border-top-1 border-300">

          <li class="flex align-items-center py-3 px-2 flex-wrap justify-content-between gap-3">
            <div class="text-500 font-medium">Status</div>
            <div class="text-900 text-end">
              <p-tag icon="pi pi-circle-fill" [value]="ticket.ticketStatus" [rounded]="true"></p-tag>
            </div>
          </li>

          <li class="flex align-items-center py-3 px-2 flex-wrap justify-content-between gap-3">
            <div class="text-500 font-medium">Erstellt am</div>
            <div class="text-900 text-end">{{ ticket.createdDate | date:"dd.MM.YYYY" }}</div>
          </li>

          <li class="flex align-items-center py-3 px-2 flex-column gap-3">
            <!--            <div class="text-500 w-full font-medium">Beschreibung</div>-->
            <div class="text-900 w-full line-height-3" [innerHTML]="ticket.euDescription"></div>
            <!--            <div class="text-900 w-full line-height-3">{{ ticket.euDescription }}</div>-->
          </li>

          <li class="flex align-items-center py-3 px-2 flex-column gap-3">
            <div class="text-500 w-full font-medium">Dokument hochladen</div>
            <div class="text-900 w-full line-height-3">
              <core-upload
                [busy]="documentUploadBusy"
                (onDocumentUploaded)="handleFileUpload($event)"
                (onSelect)="handleFileSelect($event)"
                (onClear)="handleFileClear()"
              ></core-upload>
            </div>
          </li>

          @if (ticket?.documents?.length) {
            <li class="flex align-items-center py-3 px-2 flex-column gap-3">
              <div class="text-500 w-full font-medium">Dokumente</div>

              <div class="text-900 w-full">
                <div class="grid mt-0 mr-0">
                  @for (document of ticket.documents; track document.id) {
                    <div class="col-12">
                      <div
                        class="p-3 flex flex-wrap gap-4 align-items-center justify-content-between border-1 surface-border border-round surface-card">

                        <div class="flex gap-2">
                          <i class="pi pi-file-pdf pt-1"></i>
                          <div class="flex flex-column gap-1">
                            <span class="font-medium">{{ document.documentName }}</span>
                            <span class="text-700">
                        {{ document.uploadedOnString }}
                        </span>
                          </div>
                        </div>

                        <div class="ml-4 flex align-items-center">

                          <i class="pi pi-window-maximize mr-2 cursor-pointer"
                             (click)="onShowDocument(document)"></i>
                          <i class="pi pi-trash text-red-600 mr-2 cursor-pointer"
                             (click)="handleDeleteDocument($event,document)"></i>

                          @if (document.uploadedByEu) {
                            <p-tag styleClass="px-3" severity="info" value="von dir"></p-tag>
                          } @else {
                            <p-tag styleClass="px-3" severity="info" value="von uns"></p-tag>
                          }

                        </div>


                      </div>
                    </div>
                  }
                </div>
              </div>
            </li>
          }
        </ul>
      </div>
    </div>
    <!-- CHAT -->
    <div class="col-12 xl:col-7 p-3">
      <div class="surface-card p-4 border-round h-full">

        <div class="flex flex-column h-full">
          <div class="p-3 md:px-4 lg:px-6 lg:py-4 mt-2 overflow-y-auto custom-scrollbar" style="max-height: 53vh;">

            <!--      TICKET: DEF1000001263      -->

            @if (processedComments?.length === 0) {
              <div class="flex align-items-center justify-content-center h-full text-500 py-6">
                <span>Noch keine Nachrichten vorhanden.</span>
              </div>
            } @else {
              @for (comment of processedComments; track comment.id) {
                @if (!comment.enteredByEu) {
                  <div class="grid grid-nogutter mb-4">
                    <div class="col mt-3">
                      <p class="text-900 font-semibold mb-3">Klaus versichert</p>
                      <span
                        class="text-700 inline-block border-1 surface-border shadow-1 p-3 white-space-normal border-round line-height-3"
                        style="word-break: break-word; max-width: 85%;"
                        [innerHTML]="comment.safeHtml">
                      </span>
                      @if (comment.isLoadingImages) {
                        <div class="flex align-items-center gap-2 mt-2 text-500">
                          <i class="pi pi-spin pi-spinner"></i>
                          <span class="text-sm">Bilder werden geladen...</span>
                        </div>
                      }
                      <p class="text-700 mt-3">
                        {{ comment.enteredOnString }}
                        <i class="pi pi-check ml-2 text-green-400"></i>
                      </p>
                    </div>
                  </div>
                } @else {
                  <div class="grid grid-nogutter mb-4">
                    <div class="col mt-3 text-right">
                      <span
                        class="inline-block text-left line-height-3 border-1 surface-border bg-indigo-600 text-white p-3
                                     white-space-normal border-round clickable-comment"
                        style="word-break: break-word; max-width: 85%;"
                        [innerHTML]="comment.safeHtml">
                      </span>
                      @if (comment.isLoadingImages) {
                        <div class="flex align-items-center justify-content-end gap-2 mt-2 text-500">
                          <i class="pi pi-spin pi-spinner"></i>
                          <span class="text-sm">Bilder werden geladen...</span>
                        </div>
                      }
                      <p class="text-700 mt-3">
                        {{ comment.enteredOnString }}
                        <i class="pi pi-check ml-2 text-green-400"></i>
                      </p>
                    </div>
                  </div>
                }
              }
            }

          </div>

          <div
            class="p-3 md:p-4 lg:p-6 flex flex-column sm:flex-row align-items-center mt-auto border-top-1 surface-border gap-3">
            <input id="message" type="text" pinputtext="" placeholder="Gib deinen Text ein" [(ngModel)]="enteredComment"
                   class="p-inputtext p-component p-element flex-1 w-full sm:w-auto border-round ng-valid ng-touched ng-dirty"
                   (keydown.enter)="handlePostMessage()">
            <div class="flex w-full sm:w-auto gap-3">

              @if (!selectedComment) {
                <button pbutton="" pripple="" label="Send" icon="pi pi-send"
                        class="p-element p-ripple w-full sm:w-auto p-button p-component" (click)="handlePostMessage()"
                        [disabled]="busy">
                  @if (busy) {
                    <p-progressSpinner styleClass="w-2rem h-2rem" strokeWidth="8" fill="var(--surface-ground)"
                                       animationDuration=".5s"></p-progressSpinner>
                  }
                  <span class="p-button-icon p-button-icon-left pi pi-send" aria-hidden="true"></span>
                  <span class="p-button-label">Senden</span>
                  <span class="p-ink" aria-hidden="true" role="presentation"></span>
                </button>
              } @else {
                @if (busy) {
                  <p-progressSpinner styleClass="w-2rem h-2rem" strokeWidth="8" fill="var(--surface-ground)"
                                     animationDuration=".5s"></p-progressSpinner>
                }
                <app-button [busy]="busy"
                            [icon]="'pi pi-trash'"
                            [tooltip]="'Kommentar löschen'"
                            [label]="''"
                            [showIcon]="true"
                            severity="danger"
                            (onClick)="handleDeleteComment()">
                </app-button>
                <app-button [busy]="busy"
                            [icon]="'pi pi-send'"
                            [label]="''"
                            [showIcon]="true"
                            [tooltip]="'Überarbeiten'"
                            (onClick)="handleUpdateComment()">
                </app-button>
                <p-button icon="pi pi-times" pTooltip="Abbrechen" (onClick)="handleCancelUpdate()"
                          [disabled]="busy" severity="secondary"></p-button>
              }
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>

  <p-dialog
    [header]="selectedDocument?.documentName"
    *ngIf="visible"
    [(visible)]="visible"
    [style]="{width: '65rem', height: '75vh'}"
    [modal]="true"
    (onHide)="selectedDocument = undefined"
  >
    @if (selectedDocument) {
      <app-pdf-view [objectService]="ticketsApiService"
                    [documentId]="selectedDocument?.id"
                    [addedId]="ticket.id"
                    class="w-full h-full">
      </app-pdf-view>
    }

  </p-dialog>


}


<p-confirmDialog></p-confirmDialog>
